const uploadFineNoticeStyle = {
  button: {
    marginTop: "1rem",
  },
};

export default uploadFineNoticeStyle;
